import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiTutorBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame 289919",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group 5240",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 188",
					d: "M15.891 9.62833L14.6973 12.6481L11.6072 13.7995C11.1913 13.9544 11.1779 14.5379 11.5864 14.7118L14.6973 16.0357L15.8903 19.0904C16.053 19.5072 16.6427 19.5072 16.8054 19.0904L17.9984 16.0357L20.9394 14.7072C21.3349 14.5285 21.3214 13.9623 20.9179 13.8027L17.9984 12.6481L16.8047 9.62833C16.641 9.21414 16.0548 9.21414 15.891 9.62833Z",
					fill: "#4F46E5"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 189",
					opacity: .6,
					d: "M10.8054 16.9721L10.3479 18.1054L9.18162 18.5309C8.76136 18.6843 8.74809 19.2738 9.16103 19.4458L10.3479 19.9404L10.8046 21.0857C10.9691 21.498 11.5527 21.498 11.7172 21.0857L12.174 19.9404L13.3022 19.4414C13.7023 19.2644 13.6888 18.6921 13.2808 18.5341L12.174 18.1054L11.7164 16.9721C11.551 16.5623 10.9708 16.5623 10.8054 16.9721Z",
					fill: "#4F46E5"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 190",
					opacity: .5,
					d: "M11.3388 7.3385L10.9136 8.39181L9.82324 8.78961C9.69716 8.83561 9.69318 9.01246 9.81706 9.06408L10.9136 9.52102L11.3386 10.5866C11.3879 10.7103 11.563 10.7103 11.6124 10.5866L12.0374 9.52102L13.0734 9.06275C13.1935 9.00966 13.1894 8.83795 13.067 8.79056L12.0374 8.39181L11.6121 7.3385C11.5625 7.21556 11.3884 7.21556 11.3388 7.3385Z",
					fill: "#4F46E5"
				})
			]
		})
	})
});
export default SvgIconAiTutorBlue;
